import React, { useState, useEffect } from 'react';

// project-imports
import { useEnquiryContext } from '../../context/enquiry_context';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import { isBlockedDomain } from '../../utils';
import { Modal } from 'react-bootstrap';

// Reading environment variables
const INVALID_NAME_ERROR_MESSAGE = process.env.REACT_APP_INVALID_FULLNAME_ERROR_MESSAGE;
const INVALID_EMAIL_ERROR_MESSAGE = process.env.REACT_APP_INVALID_EMAIL_ERROR_MESSAGE;
const NAME_ERROR_MESSAGE = process.env.REACT_APP_NAME_ERROR_MESSAGE;
const EMAIL_ERROR_MESSAGE = process.env.REACT_APP_EMAIL_ERROR_MESSAGE;
const PHONE_ERROR_MESSAGE = process.env.REACT_APP_PHONE_ERROR_MESSAGE;
const MESSAGE_ERROR_MESSAGE = process.env.REACT_APP_MESSAGE_ERROR_MESSAGE;

function TalkToSalesForm({ formStyle, show, onCloseModal, data }) {

    // Reading Context methods and variables
    const { submitEnquiry, isLoading } = useEnquiryContext();

    const subjectTitle = data && data ? data?.name : "";
    const trainingPeriod = data ? data?.pricing?.billingCycle : "";
    const subject = `Website Inquiry : ${subjectTitle} (${trainingPeriod})`
    const message = `Hello Sales Team, I am interested in the ${subjectTitle} (${trainingPeriod}) program. I would like to learn more about the role requirements, application deadlines, and onboarding process. Could you please direct me to the right team or share more details? Thank you.`;

    // Local stat initialization
    const [result, setResult] = useState(false);
    const [enquiryForm, setEnquiryForm] = useState({
        name: '',
        email: '',
        phone: '',
        subject: subject,
        message: message,
    });
    const [inputValidationErrors, setInputValidationErrors] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
    });

    // Constant variable
    const patterns = {
        name: /^[A-Za-z\s]{3,20}$/,
        email: /^[a-zA-Z0-9!#$%&*+=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&*=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,}(?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
        phone: /^[6-9]\d{9}$/,
        subject: /^[A-Za-z0-9\s]{3,50}$/,
        message: /^[\w\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{3,500}$/
    };

    // Constant functions
    // Validation handler
    const validateField = (data, name) => {
        try {
            // const isValid = patterns[name].test(data[name]?.value);
            let validationObj = {};
            if (name === "name" || name === "all") {
                if (data && (!data.name || (data.name && !data.name.length))) {
                    validationObj.name = "Name is required!"
                } else if (data && data.name && !(patterns["name"].test(data?.name))) {
                    validationObj.name = NAME_ERROR_MESSAGE;
                } else if (data && data.name && isBlockedDomain(data?.name)) {
                    validationObj.name = INVALID_NAME_ERROR_MESSAGE;
                } else {
                    validationObj.name = "";
                }
            }
            if (name === "email" || name === "all") {
                if (data && (!data.email || (data.email && !data.email.length))) {
                    validationObj.email = "Email is required!"
                } else if (data && data.email && !(patterns["email"].test(data?.email))) {
                    validationObj.email = EMAIL_ERROR_MESSAGE;
                } else if (data && data.email && isBlockedDomain(data?.email)) {
                    validationObj.email = INVALID_EMAIL_ERROR_MESSAGE;
                } else {
                    validationObj.email = "";
                }
            }
            if (name === "phone" || name === "all") {
                if (data && (!data.phone || (data.phone && !data.phone.length))) {
                    validationObj.phone = "Phone No. is required!"
                } else if (data && data.phone && !(patterns["phone"].test(data?.phone))) {
                    validationObj.phone = PHONE_ERROR_MESSAGE;
                } else {
                    validationObj.phone = "";
                }
            }

            if (name === "message" || name === "all") {
                if (data && (!data.message || (data.message && !data.message.length))) {
                    validationObj.message = "Message is required!"
                } else if (data && data.message && !(patterns["message"].test(data?.message))) {
                    validationObj.message = MESSAGE_ERROR_MESSAGE;
                } else {
                    validationObj.message = "";
                }
            }
            setInputValidationErrors(validationObj);
            return validationObj;
        } catch (error) {
            console.log("105 : ContactUsForm : Error while checking validation :", error && JSON.stringify(error));
            throw error;
        }
    };

    const handleChange = (e) => {
        try {
            const { name, value } = e.target;

            const data = {
                [name]: value
            };

            setInputValidationErrors((prev) => ({ ...prev, ...validateField(data, name) }));
            setEnquiryForm((prev) => ({ ...prev, ...data }));
        } catch (error) {
            console.log("121 : ContactUsForm : Error while changing value :", error && JSON.stringify(error));
            throw error;
        }
    };

    const handleSubmitEnquiry = () => {
        try {

            let isFormValid = true;
            const valid = validateField(enquiryForm, "all");

            if (valid.name || valid.email || valid.phone || valid.subject || valid.message) {
                isFormValid = false;
            }

            if (isFormValid) {

                const isAnyFieldEmpty = Object.values(enquiryForm).some((val) => !val.trim());
                const hasValidationErrors = Object.values(inputValidationErrors).some((error) => error);

                if (isAnyFieldEmpty || hasValidationErrors) {
                    return;
                }

                triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.CONTACT_US_FORM_SUBMIT_BUTTON);
                submitEnquiry(enquiryForm);

                // e.target.reset();
                setEnquiryForm({
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: ''
                });
                setResult(true);
            }
        } catch (error) {
            console.log("159 : ContactUsForm : Error while submitting message :", error && JSON.stringify(error));
            throw error;
        }
    };

    // Reset result message after 2s
    useEffect(() => {
        if (result) {
            const timer = setTimeout(() => setResult(false), 2000);
            return () => clearTimeout(timer);
        }
    }, [result]);

    return (
        <div>
            <Modal className="rounded-lg" show={show} onHide={() => { onCloseModal(); triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.TESTIMONIAL_FORM_CLOSED) }} aria-labelledby="contained-modal-title-vcenter" centered size="lg">
                <Modal.Header closeButton className="px-5 pb-0 border-0">
                    <Modal.Title as={'h5'} className="mb-0" >Talk to Sales</Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-5 pb-4">
                    {/* <div class="hs-form-frame" data-region="na2" data-form-id="3ab0326f-0f35-44cf-8a90-0efb382ed613" data-portal-id="242859014"></div> */}
                    <div className={formStyle}>
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label htmlFor='name'>Enter Name*</label>
                                <input
                                    disabled={isLoading}
                                    type="text"
                                    value={enquiryForm?.name || ""}
                                    name="name"
                                    placeholder="Name*"
                                    className="form-control form-control-lg"
                                    onChange={handleChange}
                                    autoFocus
                                />
                                {inputValidationErrors && inputValidationErrors.name && (
                                    <div className="invalid-data">{inputValidationErrors.name}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="form-group">
                                <label htmlFor='email'>Enter Email Address*</label>
                                <input
                                    disabled={isLoading}
                                    type="email"
                                    name="email"
                                    value={enquiryForm?.email || ""}
                                    placeholder="Email*"
                                    className="form-control form-control-lg"
                                    onChange={handleChange}
                                    title="Please enter a valid email"
                                />
                                {inputValidationErrors && inputValidationErrors.email && (
                                    <div className="invalid-data">{inputValidationErrors.email}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="form-group">
                                <label htmlFor='phone'>Enter Phone Number*</label>
                                <input
                                    disabled={isLoading}
                                    type="text"
                                    name="phone"
                                    value={enquiryForm?.phone || ""}
                                    placeholder="Phone*"
                                    className="form-control form-control-lg"
                                    onChange={handleChange}
                                />
                                {inputValidationErrors && inputValidationErrors.phone && (
                                    <div className="invalid-data">{inputValidationErrors.phone}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="form-group">
                                <label htmlFor='subject'>Subject</label>
                                <input
                                    disabled
                                    type="text"
                                    name="subject"
                                    value={enquiryForm?.subject || ""}
                                    placeholder="Subject"
                                    className="form-control form-control-lg"
                                    onChange={handleChange}
                                />

                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="form-group">
                                <label htmlFor='message'>Message</label>
                                <textarea
                                    name="message"
                                    value={enquiryForm?.message || ""}
                                    placeholder="Your Message"
                                    className="form-control"
                                    onChange={handleChange}
                                />

                                {inputValidationErrors && inputValidationErrors.message && (
                                    <div className="invalid-data">{inputValidationErrors.message}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="form-group">
                                <button
                                    disabled={isLoading}
                                    className={`rn-btn edu-btn w-100 ${isLoading ? 'btn-loading' : ''}`}
                                    type="button"
                                    onClick={handleSubmitEnquiry}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                            Loading...
                                        </>
                                    ) : (
                                        <>
                                            <span>Submit Now</span>
                                            <i className="icon-arrow-right-line-right" />
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>

                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default TalkToSalesForm;
